// extracted by mini-css-extract-plugin
export default {"item":"Loaded_item__qSWeM"};